function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".elected-officials_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill:#1976d2}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "elected-officials_svg__st0",
  d: "M9.9 20.5l5-4.6c-.6-.1-1.1-.1-1.7-.1C6.8 15.6 0 19.7 0 22.1c0 0 2.2 4.9 8.1 7.5 3.9 1.7 7.6 2.3 11.5 1.6L9.9 20.5zm3.4-7.9c3.7 0 6.6-2.8 6.6-6.3S16.9 0 13.3 0C9.6 0 6.6 2.8 6.6 6.3s3 6.3 6.7 6.3z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "elected-officials_svg__st0",
  d: "M20.7 26.1l-5.8-5.5 2.3-2.2 3.4 3.3 8.5-8.2 2.3 2.2-10.7 10.4z"
});

function SvgElectedOfficials(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "elected-officials_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 31.5 31.5",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
}

export default SvgElectedOfficials;